import React, { useState } from 'react';
import { toast } from 'sonner';
import { Download, FileText, Database, Globe, ArrowDownToLine } from 'lucide-react';

import { authHeaders } from '../lib/authToken';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminExports() {
  const [dateDebut, setDateDebut] = useState('');
  const [dateFin, setDateFin] = useState('');
  const [loading, setLoading] = useState({});

  async function downloadDougsCSV() {
    setLoading(l => ({ ...l, dougs: true }));
    try {
      let url = `${BACKEND}/api/export/dougs/export-csv`;
      const params = new URLSearchParams();
      if (dateDebut) params.append('date_debut', dateDebut);
      if (dateFin) params.append('date_fin', dateFin);
      if (params.toString()) url += '?' + params.toString();

      const res = await fetch(url, { headers: authHeaders() });
      if (res.ok) {
        const blob = await res.blob();
        const dl = document.createElement('a');
        dl.href = window.URL.createObjectURL(blob);
        dl.download = `export_dougs_${new Date().toISOString().split('T')[0]}.csv`;
        dl.click();
        toast.success('Export Dougs téléchargé !');
      }
    } catch (e) { toast.error('Erreur export'); }
    setLoading(l => ({ ...l, dougs: false }));
  }

  async function fetchOdooProducts() {
    setLoading(l => ({ ...l, odoo_prod: true }));
    try {
      const res = await fetch(`${BACKEND}/api/export/odoo/produits`, { headers: authHeaders() });
      const data = await res.json();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const dl = document.createElement('a');
      dl.href = window.URL.createObjectURL(blob);
      dl.download = `odoo_produits_${new Date().toISOString().split('T')[0]}.json`;
      dl.click();
      toast.success(`${data.total} produits exportés`);
    } catch (e) { toast.error('Erreur'); }
    setLoading(l => ({ ...l, odoo_prod: false }));
  }

  async function fetchOdooQuotes() {
    setLoading(l => ({ ...l, odoo_devis: true }));
    try {
      const res = await fetch(`${BACKEND}/api/export/odoo/devis`, { headers: authHeaders() });
      const data = await res.json();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const dl = document.createElement('a');
      dl.href = window.URL.createObjectURL(blob);
      dl.download = `odoo_devis_${new Date().toISOString().split('T')[0]}.json`;
      dl.click();
      toast.success(`${data.total} devis exportés`);
    } catch (e) { toast.error('Erreur'); }
    setLoading(l => ({ ...l, odoo_devis: false }));
  }

  return (
    <div className="max-w-2xl">
      <div className="mb-6">
        <h2 className="font-display text-xl font-bold" style={{ color: 'var(--admin-text)' }}>Exports & Connecteurs</h2>
        <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>Exports Dougs CSV + pré-connecteur Odoo JSON</p>
      </div>

      {/* Dougs Export */}
      <div className="p-5 rounded-xl mb-4" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(212,175,55,0.12)', color: 'var(--admin-gold)' }}>
            <FileText size={18} />
          </div>
          <div>
            <h3 className="font-semibold text-sm" style={{ color: 'var(--admin-text)' }}>Export Dougs CSV</h3>
            <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>Colonnes: client, montant, TVA, acompte, solde, date, référence</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3 mb-4">
          <div>
            <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Date début</label>
            <input type="date" value={dateDebut} onChange={e => setDateDebut(e.target.value)}
              className="w-full px-3 py-2 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
          </div>
          <div>
            <label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Date fin</label>
            <input type="date" value={dateFin} onChange={e => setDateFin(e.target.value)}
              className="w-full px-3 py-2 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
          </div>
        </div>
        <button
          onClick={downloadDougsCSV}
          disabled={loading.dougs}
          className="btn-gold px-5 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2 disabled:opacity-50"
        >
          <Download size={16} />
          {loading.dougs ? 'Export...' : 'Télécharger CSV Dougs'}
        </button>
      </div>

      {/* Odoo Pre-connector */}
      <div className="p-5 rounded-xl mb-4" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(197,216,249,0.12)', color: '#C5D8F9' }}>
            <Database size={18} />
          </div>
          <div>
            <h3 className="font-semibold text-sm" style={{ color: 'var(--admin-text)' }}>Pré-connecteur Odoo</h3>
            <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>Exports JSON format compatible Odoo</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {[
            { label: 'Produits', action: fetchOdooProducts, key: 'odoo_prod' },
            { label: 'Devis & commandes', action: fetchOdooQuotes, key: 'odoo_devis' },
          ].map((item, i) => (
            <button
              key={`action-${i}`}
              onClick={item.action}
              disabled={loading[item.key]}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium disabled:opacity-50"
              style={{ background: 'rgba(197,216,249,0.08)', color: '#C5D8F9', border: '1px solid rgba(197,216,249,0.2)' }}
            >
              <ArrowDownToLine size={14} />
              {loading[item.key] ? 'Export...' : `Export ${item.label}`}
            </button>
          ))}
        </div>
      </div>

      {/* API Endpoints info */}
      <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(61,220,151,0.12)', color: '#3DDC97' }}>
            <Globe size={18} />
          </div>
          <div>
            <h3 className="font-semibold text-sm" style={{ color: 'var(--admin-text)' }}>Endpoints API REST</h3>
            <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>Pré-connecteur public pour intégrations futures</p>
          </div>
        </div>
        <div className="space-y-2">
          {[
            { method: 'GET', path: '/api/export/odoo/produits', desc: 'Liste produits format Odoo' },
            { method: 'GET', path: '/api/export/odoo/clients', desc: 'Liste clients format Odoo' },
            { method: 'GET', path: '/api/export/odoo/devis', desc: 'Devis format Odoo' },
            { method: 'GET', path: '/api/export/odoo/commandes', desc: 'Commandes confirmées' },
            { method: 'GET', path: '/api/export/dougs/export-csv', desc: 'Export CSV comptable Dougs' },
            { method: 'POST', path: '/api/export/webhooks/order-paid', desc: 'Webhook paiement reçu' },
            { method: 'POST', path: '/api/export/webhooks/quote-signed', desc: 'Webhook devis signé' },
          ].map((e, i) => (
            <div key={`list-${i}`} className="flex items-center gap-3 py-2" style={{ borderBottom: '1px solid rgba(42,42,42,0.5)' }}>
              <span className="font-mono-ose text-xs px-2 py-0.5 rounded" style={{
                background: e.method === 'GET' ? 'rgba(61,220,151,0.1)' : 'rgba(212,175,55,0.1)',
                color: e.method === 'GET' ? '#3DDC97' : '#D4AF37'
              }}>{e.method}</span>
              <span className="font-mono-ose text-xs flex-1 truncate" style={{ color: 'rgba(255,255,255,0.6)' }}>{e.path}</span>
              <span className="text-xs" style={{ color: 'var(--admin-faint)' }}>{e.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
